module.exports = __webpack_public_path__ + "static/img/fun6.43864ad0.png";